class Wishlist {
  constructor() {
    this.storageKey = 'vet_wishlist';
    this.items = this.load();
    this.init();
  }

  load() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    } catch {
      return [];
    }
  }

  save() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.items));
  }

  has(productId) {
    return this.items.some((item) => item.id === productId);
  }

  add(product) {
    if (!this.has(product.id)) {
      this.items.push(product);
      this.save();
    }
  }

  remove(productId) {
    this.items = this.items.filter((item) => item.id !== productId);
    this.save();
  }

  toggle(product) {
    if (this.has(product.id)) {
      this.remove(product.id);
      return false;
    } else {
      this.add(product);
      return true;
    }
  }

  updateCount() {
    const bubble = document.querySelector('.wishlist-count-bubble');
    if (!bubble) return;
    const count = this.items.length;
    bubble.hidden = count === 0;
    const countEl = bubble.querySelector('[data-wishlist-count]');
    if (countEl) countEl.textContent = count;
  }

  initButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach((btn) => {
      const id = parseInt(btn.dataset.productId);
      btn.setAttribute('aria-pressed', this.has(id) ? 'true' : 'false');
      btn.classList.toggle('is-wishlisted', this.has(id));

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const product = {
          id: parseInt(btn.dataset.productId),
          title: btn.dataset.productTitle,
          url: btn.dataset.productUrl,
          image: btn.dataset.productImage,
          price: btn.dataset.productPrice,
        };
        const added = this.toggle(product);
        document
          .querySelectorAll(`[data-wishlist-btn][data-product-id="${product.id}"]`)
          .forEach((b) => {
            b.classList.toggle('is-wishlisted', added);
            b.setAttribute('aria-pressed', added ? 'true' : 'false');
          });
        this.updateCount();
      });
    });
  }

  renderPage(container) {
    if (this.items.length === 0) {
      container.innerHTML =
        '<p class="wishlist-empty">Your wishlist is empty. Browse our <a href="/collections/all">full collection</a> to add pieces you love.</p>';
      return;
    }

    const html = this.items
      .map(
        (item) => `
      <div class="wishlist-item" data-wishlist-item="${item.id}">
        <a href="${item.url}" class="wishlist-item__image-link">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : '<div class="wishlist-item__no-image"></div>'}
        </a>
        <div class="wishlist-item__info">
          <h3 class="wishlist-item__title"><a href="${item.url}">${item.title}</a></h3>
          <p class="wishlist-item__price">${item.price}</p>
          <div class="wishlist-item__actions">
            <a href="${item.url}" class="button button--secondary">View Ring</a>
            <button class="wishlist-item__remove link" data-remove-id="${item.id}" aria-label="Remove ${item.title} from wishlist">Remove</button>
          </div>
        </div>
      </div>`
      )
      .join('');

    container.innerHTML = `<div class="wishlist-grid">${html}</div>`;

    container.querySelectorAll('[data-remove-id]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = parseInt(btn.dataset.removeId);
        this.remove(id);
        container.querySelector(`[data-wishlist-item="${id}"]`)?.remove();
        this.updateCount();
        if (this.items.length === 0) {
          container.innerHTML =
            '<p class="wishlist-empty">Your wishlist is empty. Browse our <a href="/collections/all">full collection</a> to add pieces you love.</p>';
        }
        document
          .querySelectorAll(`[data-wishlist-btn][data-product-id="${id}"]`)
          .forEach((b) => {
            b.classList.remove('is-wishlisted');
            b.setAttribute('aria-pressed', 'false');
          });
      });
    });
  }

  init() {
    this.updateCount();
    this.initButtons();

    const wishlistPage = document.querySelector('[data-wishlist-page]');
    if (wishlistPage) this.renderPage(wishlistPage);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.wishlist = new Wishlist();
});
